/**
 * Replaces any "Pagar.me" / "Pagarme" / "PagarMe" occurrence with "Stone".
 * Used to Stone-ify page titles (and any brand text) at runtime when the
 * `stone-rebrand` feature flag is on. No-op for empty/undefined input.
 */
export function toStoneBrand (text) {
  if (!text) return text
  return text.replace(/pagar\.?me/gi, 'Stone')
}
